import { inject, Injectable } from '@angular/core';
import { PublicRestService, PublicSkupinySablonFiltrDto, PublicSkupinySablonVysledekDto } from '@generated/be';
import { BrowseStateService, DEFAULT_PAGE_LIMIT, publicApiArgs } from '@shared/utils';
import { Observable } from 'rxjs';

/** Veřejný katalog skupin šablon: stav přehledu (filtr + stránkovaný výsledek), bez řazení. */
@Injectable()
export class KatalogSkupinSablonStateService extends BrowseStateService<
  PublicSkupinySablonFiltrDto,
  PublicSkupinySablonVysledekDto
> {
  private readonly publicRestService = inject(PublicRestService);

  protected override readonly pagingMode = 'list';
  protected readonly defaultFilter: PublicSkupinySablonFiltrDto = {
    pageAndSortList: { start: 0, count: DEFAULT_PAGE_LIMIT, sortListPage: [] },
  };
  protected readonly emptyResult: PublicSkupinySablonVysledekDto = { total: 0, content: [] };

  constructor() {
    super();
    this.initBrowse();
  }

  protected search(filter: PublicSkupinySablonFiltrDto): Observable<PublicSkupinySablonVysledekDto> {
    return this.publicRestService.vyhledatPublicSkupinySablon(
      { publicSkupinySablonFiltrDto: filter },
      ...publicApiArgs()
    );
  }
}
